/* template */
<template minapp="mpx" xlang="wxml"><tab-bar :checkTabIndex="(checkTabIndex)"><div slot="tab_buy"><ticket-bar/></div><div slot="tab_cross"><crossPort-tab/></div><div slot="tab_refund"><refund-tab/></div><div slot="tab_change"><rebook-tab/></div><div slot="tab_scramble"><scramble-tab/></div><div slot="tab_student"><student-tab/></div><div slot="tab_child"><children-tab/></div></tab-bar></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mf94e180a"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf94e180a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mf94e180a"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'tab-bar':getComponent(require("./components/tab-bar.mpx?isComponent&outputPath=components%2Ftab-bar074ce287%2Findex")),'ticket-bar':getComponent(require("./components/ticket-bar.mpx?isComponent&outputPath=components%2Fticket-barc04025d8%2Findex")),'refund-tab':getComponent(require("./components/refund-tab.mpx?isComponent&outputPath=components%2Frefund-tab13b8e802%2Findex")),'rebook-tab':getComponent(require("./components/rebook-tab.mpx?isComponent&outputPath=components%2Frebook-tab79be9c26%2Findex")),'scramble-tab':getComponent(require("./components/scramble-tab.mpx?isComponent&outputPath=components%2Fscramble-tab5c794b97%2Findex")),'student-tab':getComponent(require("./components/student-tab.mpx?isComponent&outputPath=components%2Fstudent-tab06c651a2%2Findex")),'children-tab':getComponent(require("./components/children-tab.mpx?isComponent&outputPath=components%2Fchildren-tab3628466e%2Findex")),'crossPort-tab':getComponent(require("./components/crossPort-tab.mpx?isComponent&outputPath=components%2FcrossPort-tabb76ae2d6%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
